import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { UiIconComponent } from '../../shared/ui/icon/icon.component';
import { FaqService } from '../../shared/faq/faq.service';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-faq-page',
  imports: [UiIconComponent],
  templateUrl: './faq-page.component.html',
  styleUrl: './faq-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqPageComponent {
  readonly isPreLoginPage = input<boolean>(false);
  private readonly faqService = inject(FaqService);
  readonly sections = toSignal(
    toObservable(this.isPreLoginPage).pipe(switchMap((v) => this.faqService.getFaqs(v))),
    { initialValue: [] },
  );

  private readonly expandedIds = signal<Set<string>>(new Set());

  isExpanded(id: string): boolean {
    return this.expandedIds().has(id);
  }

  toggle(id: string): void {
    const next = new Set(this.expandedIds());
    if (next.has(id)) next.delete(id);
    else next.add(id);
    this.expandedIds.set(next);
  }
}
